<div class="documents-card-content">
  <div class="documents-header">
    <umss-card-header iconName="phosphorFileText" title="Documents" />
    @if (showFilter()) {
      <div class="documents-filter">
        <umss-contractor-document-type-select
          [clearable]="true"
          placeholder="All document types"
          [(value)]="selectedDocumentType"
          size="Small"
        />
      </div>
    }
  </div>

  <div class="documents-list-container">
    @if (loading()) {
      <div class="skeleton-container">
        @for (item of [1, 2, 3]; track item) {
          <div class="document-item-skeleton">
            <umss-skeleton variant="Avatar" [spacingX]="8" [spacingY]="8" />
            <div class="skeleton-text-group">
              <umss-skeleton variant="Line" [spacingX]="40" [spacingY]="4" />
              <umss-skeleton variant="Line" [spacingX]="20" [spacingY]="3" />
            </div>
          </div>
        }
      </div>
    } @else if (visibleDocuments().length === 0) {
      <umss-empty-state
        iconName="phosphorFileText"
        title="No documents found"
        [description]="
          selectedDocumentType()
            ? 'No documents match the selected filter.'
            : 'This professional has no documents uploaded yet.'
        "
        [showButton]="false"
      />
    } @else {
      <div class="documents-grid">
        @for (doc of visibleDocuments(); track doc.id) {
          <div
            class="document-item"
            [class.clickable]="clickableCards()"
            [attr.role]="clickableCards() ? 'button' : null"
            [attr.tabindex]="clickableCards() ? 0 : null"
            (click)="clickableCards() && openDocument(doc.previewUrl)"
            (keydown.enter)="clickableCards() && openDocument(doc.previewUrl)"
            (keydown.space)="clickableCards() && openDocument(doc.previewUrl)"
          >
            <umss-document-thumbnail
              [fileName]="doc.fileName"
              [thumbnailUrl]="doc.thumbnailUrl"
            />
            <div class="doc-info">
              <span class="doc-name" [title]="doc.fileName">{{
                doc.fileName
              }}</span>

              @if (showTypeSubtitle()) {
                <span class="doc-type">{{
                  getDocumentTypeLabel(doc.documentType)
                }}</span>
              }
            </div>
            @if (!clickableCards()) {
              <div class="doc-actions">
                <umss-button
                  variant="Secondary"
                  leftIconName="phosphorEye"
                  label="View"
                  (onClick)="openDocument(doc.previewUrl)"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
